import React, { useEffect, useState, useRef } from "react";
import { FiBell } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
 
const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
 
  const role = sessionStorage.getItem("role");
  const token = sessionStorage.getItem("token");
 
  const allowedRoles = ["Operations", "QC", "Super_admin", "admin"];
 
  /* ===============================
     RESPONSIVE CHECK
  =============================== */
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );
 
  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerWidth <= 768);
 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  /* ===============================
     FETCH
  =============================== */
  const fetchNotifications = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/notifications",
        {
          params: { role },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
 
      setNotifications(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };
 
  useEffect(() => {
    if (!allowedRoles.includes(role)) return;
 
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 5000);
    return () => clearInterval(interval);
  }, []);
 
  /* ===============================
     CLOSE OUTSIDE
  =============================== */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current &&
          !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
 
    document.addEventListener("click", handleClickOutside);
    return () =>
      document.removeEventListener("click", handleClickOutside);
  }, []);
 
  const handleClick = (n) => {
    if (n.redirect_url) navigate(n.redirect_url);
    setOpen(false);
  };
 
  if (!allowedRoles.includes(role)) return null;
 
  /* ===============================
     STYLES (JSX CSS)
  =============================== */
 
  const styles = {
    wrapper: {
      position: "relative",
    },
 
    bell: {
      cursor: "pointer",
      padding: "6px",
      borderRadius: "50%",
      border: "none",
      background: "transparent",
    },
 
    badge: {
      position: "absolute",
      top: 2,
      right: 2,
      background: "#dc3545",
      color: "#fff",
      borderRadius: "50%",
      fontSize: 11,
      padding: "2px 6px",
      fontWeight: 600,
    },
 
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.35)",
      zIndex: 1200,
    },
 
    dropdown: {
      position: isMobile ? "fixed" : "absolute",
      top: isMobile ? "65px" : "120%",
      right: isMobile ? "12px" : 0,
      left: isMobile ? "12px" : "auto",
      width: isMobile ? "auto" : "360px",
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
      overflow: "hidden",
      zIndex: 1300,
    },
 
    header: {
      padding: "12px 16px",
      fontWeight: 600,
      background: "#f8f9fa",
      borderBottom: "1px solid #eee",
    },
 
    list: {
      maxHeight: isMobile ? "60vh" : "320px",
      overflowY: "auto",
    },
 
    item: {
      padding: "12px 16px",
      cursor: "pointer",
      borderBottom: "1px solid #f1f1f1",
      fontSize: 14,
    },
 
    empty: {
      padding: 16,
      textAlign: "center",
      color: "#777",
    },
  };
 
  /* ===============================
     UI
  =============================== */
 
  return (
    <div style={styles.wrapper} ref={dropdownRef}>
     
      {/* Bell */}
      <button
        style={styles.bell}
        onClick={() => setOpen(!open)}
      >
        <FiBell size={22} />
      </button>
 
      {/* Badge */}
      {notifications.length > 0 && (
        <span style={styles.badge}>
          {notifications.length}
        </span>
      )}
 
      {open && (
        <>
          {isMobile && (
            <div
              style={styles.overlay}
              onClick={() => setOpen(false)}
            />
          )}
 
          <div style={styles.dropdown}>
            <div style={styles.header}>
              Notifications
            </div>
 
            <div style={styles.list}>
              {notifications.length === 0 ? (
                <div style={styles.empty}>
                  No new notifications
                </div>
              ) : (
                notifications.map((n) => (
                  <div
                    key={n.id}
                    style={styles.item}
                    onClick={() => handleClick(n)}
                  >
                    {n.message}
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
 
export default NotificationBell;
